import axios from '../../../helpers/axios';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../../../queries/query.keys';
import { ICustomerCategory } from '../interfaces/customerCategory';

export const useCustomerCategoryListByCustomer = (customerId: string) => {
    return useQuery<ICustomerCategory[], AxiosError>([QUERY_KEYS.CUSTOMER_CATEGORIES_LIST, customerId], () =>
        parseInt(customerId) > 0
            ? axios
                  .get<ICustomerCategory[]>(`customer-category/customer/${customerId}`)
                  .then((response) => response.data)
            : []
    );
};

export const useCustomerCategoryList = () => {
    return useQuery<ICustomerCategory[], AxiosError>(QUERY_KEYS.CUSTOMER_CATEGORIES_LIST, () =>
        axios.get<ICustomerCategory[]>(`customer-category`).then((response) => response.data)
    );
};
